var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg036WeldingMask = function Svg036WeldingMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 151h212v90H150z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 317c0 107.52 88.48 195 196 195s196-87.48 196-195V0H60zm60-196h60V91h30v30h91V91h30v30h61v150H120zM0 121h30v150H0zM482 121h30v150h-30z"
  })));
};
export default Svg036WeldingMask;